import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import CustomInput from "components/CustomInput/CustomInput.jsx";
import NumberMaskInput from 'components/CustomInput/NumberMaskInput.jsx';

import Button from "components/CustomButtons/Button.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CircularProgress } from "@material-ui/core";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import Api from 'api/Api.js';
import ReportEndpoints from 'api/ReportEndpoints';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

export class ConnectionStringStateObject {
    name = "";
    nameState = "";
    ip = "";
    ipState = "";
    username = "";
    usernameState = "";
    password = "";
    passwordState = "";
    database = "";
    databaseState = "";
    max_weight = 100;
}

class ConnectionStringDialog extends React.Component {

    constructor(props) {
        super(props)

        this.state =
            {
                ...new ConnectionStringStateObject(),
                loading: false
            };
    }

    change = (event, name, type = "required") => {
        var new_state = { [name + "State"]: this.state[name + "State"] };

        switch (type) {
            case "required":
                if (event.target.value) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            default:
                break;
        }
        this.setState({ ...new_state, [name]: event.target.value });
    }

    submit() {
        if (
            (this.state.nameState === 'success') &&
            (this.state.ipState === 'success') &&
            (this.state.usernameState === 'success') &&
            (this.state.passwordState === 'success') &&
            (this.state.databaseState === 'success') &&
            (this.state.max_weight)
        ) {
            this.setState({ loading: true }, () =>
                Api.post(ReportEndpoints.addConnection, this.state)
                    .then(({ data }) => {
                        this.props.close();
                        this.props.refresh(data);
                        this.setState({ loading: false })
                    })
                    .catch((e) => this.setState({ loading: false }, () => console.error(e)))
            )
        }
    }

    render() {


        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Connection String</DialogTitle>
                <DialogContent>
                    <CustomInput
                        success={this.state.nameState === "success"}
                        error={this.state.nameState === "error"}
                        labelText={
                            <span>
                                Name <small>(required)</small>
                            </span>
                        }
                        id="name"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "name"),
                            value: this.state.name,
                        }}
                    />
                    <CustomInput
                        success={this.state.ipState === "success"}
                        error={this.state.ipState === "error"}
                        labelText={
                            <span>
                                IP/Hostname <small>(required)</small>
                            </span>
                        }
                        id="ip"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "ip"),
                            value: this.state.ip,
                        }}
                    />
                    <CustomInput
                        success={this.state.usernameState === "success"}
                        error={this.state.usernameState === "error"}
                        labelText={
                            <span>
                                Username <small>(required)</small>
                            </span>
                        }
                        id="username"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "username"),
                            value: this.state.username,
                        }}
                    />
                    <CustomInput
                        success={this.state.passwordState === "success"}
                        error={this.state.passwordState === "error"}
                        labelText={
                            <span>
                                Password <small>(required)</small>
                            </span>
                        }
                        id="password"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "password"),
                            value: this.state.password,
                        }}
                    />
                    <CustomInput
                        success={this.state.databaseState === "success"}
                        error={this.state.databaseState === "error"}
                        labelText={
                            <span>
                                Database <small>(required)</small>
                            </span>
                        }
                        id="database"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "database"),
                            value: this.state.database,
                        }}
                    />
                    <NumberMaskInput
                        type="number"
                        labelText={
                            <span>
                                Max Weight <small>(required)</small>
                            </span>
                        }
                        id="max_weight"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.setState({ max_weight: event.target.value }),
                            value: this.state.max_weight,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>
                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Add Connection String
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(ConnectionStringDialog);